import request from "../../request.js"
import request2 from "../../request2.js"
import request3 from "../../request3.js"
import qs from "qs";
// 上传文件接口-阿里云
export  function uploadAliyunFile(data) {
	return request({
		url: "/file-interview/uploadAliyunFile",
		method: "POST",
		data
	})
}
// 上传文件接口
export  function uploadFileLocal(data) {
	return request({
		url: "/file-interview/uploadFileLocal",
		method: "POST",
		data
	})
}
// 上传文件接口
export  function uploadFileToTxCloudInterview(data) {
	return request({
		url: "/tx-cloud-file/uploadFileToTxCloudInterview",
		method: "POST",
		data
	})
}
// 获取腾讯云秘钥
export  function getPolicyTxCloudInterview(data) {
	return request({
		url: "/tx-cloud-file/getPolicyTxCloudInterview",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 识别身份证
export  function getIdCardInfo(data) {
	return request({
		url: "/aj-user/getIdCardInfo",
		method: "POST",
		data
	})
}
// 获取操作日志
export  function getSysLogList(data) {
	return request({
		url: "/sys-log/getSysLogList",
		method: "POST",
		data
	})
}
// 新增用户
export  function addIvUser(data) {
	return request({
		url: "/iv-user/addIvUser",
		method: "POST",
		data
	})
}
// 获取用户列表
export  function getIvUserList(data) {
	return request({
		url: "/iv-user/getIvUserList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑用户
export  function updateIvUser(data) {
	return request({
		url: "/iv-user/updateIvUser",
		method: "POST",
		data
	})
}
// 登录
export  function doLogin(data) {
	return request({
		url: "/iv-user/doLogin",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除用户
export  function deleteIvUser(data) {
	return request({
		url: "/iv-user/deleteIvUser",
		method: "POST",
		data
	})
}

// 编辑壮岗记录
export  function updateAjUserPostRecord(data) {
	return request({
		url: "/aj-user-post-record/updateAjUserPostRecord",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增面试录音 
export  function addIvAudio(data) {
	return request({
		url: "/iv-audio/addIvAudio",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取面试录音 
export  function getIvAudioList(data) {
	return request({
		url: "/iv-audio/getIvAudioList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除面试录音 
export  function deleteIvAudio(data) {
	return request({
		url: "/iv-audio/deleteIvAudio",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑面试录音 
export  function updateIvAudio(data) {
	return request({
		url: "/iv-audio/updateIvAudio",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增招聘渠道 
export  function addIvJobChannel(data) {
	return request({
		url: "/iv-job-channel/addIvJobChannel",
		method: "POST",
		data:qs.stringify(data)
	})
}

//删除招聘渠道
export  function deleteIvJobChannel(data) {
	return request({
		url: "/iv-job-channel/deleteIvJobChannel",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取招聘渠道
export  function getIvJobChannelList(data) {
	return request({
		url: "/iv-job-channel/getIvJobChannelList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑招聘渠道
export  function updateIvJobChannel(data) {
	return request({
		url: "/iv-job-channel/updateIvJobChannel",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增应聘
export  function addIvJobApplicant(data) {
	return request({
		url: "/iv-job-applicant/addIvJobApplicant",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除应聘
export  function deleteIvJobApplicant(data) {
	return request({
		url: "/iv-job-applicant/deleteIvJobApplicant",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取应聘
export  function getIvJobApplicantList(data) {
	return request({
		url: "/iv-job-applicant/getIvJobApplicantList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取应聘者（精确查询）
export  function getIvJobApplicantListSearch(data) {
	return request({
		url: "/iv-job-applicant/getIvJobApplicantListSearch",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑应聘
export  function updateIvJobApplicant(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicant",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑应聘-是否办理入职手续
export  function updateIvJobApplicantEntryStatus(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantEntryStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑应聘-到面信息
export  function updateIvJobApplicantToFace(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantToFace",
		method: "POST",
		data:qs.stringify(data)
	})
}

//编辑应聘-是否转正
export  function updateIvJobApplicantRegularWorker(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantRegularWorker",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑应聘-是否发offer
export  function updateIvJobApplicantOffer(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantOffer",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑应聘-离职
export  function updateIvJobApplicantLeave(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantLeave",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑应聘-复试
export  function updateIvJobApplicantInterviewAgain(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantInterviewAgain",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑应聘-留存
export  function updateIvJobApplicantEntryWeek(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantEntryWeek",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增统计周
export  function addIvJobDateWeek(data) {
	return request({
		url: "/iv-job-date-week/addIvJobDateWeek",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增统计周-年度所有
export  function addIvJobDateWeekYear(data) {
	return request({
		url: "/iv-job-date-week/addIvJobDateWeekYear",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增统计周-删除统计周
export  function deleteIvJobDateWeek(data) {
	return request({
		url: "/iv-job-date-week/deleteIvJobDateWeek",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取统计周
export  function getIvJobDateWeekList(data) {
	return request({
		url: "/iv-job-date-week/getIvJobDateWeekList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑统计周
export  function updateIvJobDateWeek(data) {
	return request({
		url: "/iv-job-date-week/updateIvJobDateWeek",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取应聘者详情
export  function getIvJobApplicantDetails(data) {
	return request({
		url: "/iv-job-applicant/getIvJobApplicantDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获编辑应聘者录音
export  function updateIvJobApplicantAudio(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantAudio",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获编辑应聘者简历
export  function updateIvJobApplicantFileRegisterForm(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantFileRegisterForm",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获编辑应聘者面试登记表
export  function updateIvJobApplicantBiographicalNotes(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantBiographicalNotes",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获编招聘统计
export  function getIvJobApplicantAnalysis(data) {
	return request({
		url: "/iv-home/getIvJobApplicantAnalysis",
		method: "POST",
		data:qs.stringify(data)
	})
}
//批量导入
export  function uploadNcIvJobApplicant(data) {
	return request({
		url: "/iv-job-applicant/uploadIvJobApplicant",
		method: "POST",
		data
	})
}
//批量导入-
export  function uploadImportIvJobApplicant(data) {
	return request({
		url: "/sys-import-tem/uploadImportIvJobApplicant",
		method: "POST",
		data:qs.stringify(data)
	})
}
//消息列表
export  function deleteIvNoticeRead(data) {
	return request({
		url: "/iv-notice/deleteIvNoticeRead",
		method: "POST",
		data:qs.stringify(data)
	})
}
//消息列表
export  function updateIvNoticeRead(data) {
	return request({
		url: "/iv-notice/updateIvNoticeRead",
		method: "POST",
		data:qs.stringify(data)
	})
}
//消息列表
export  function getIvNoticeUnReadNum(data) {
	return request({
		url: "/iv-notice/getIvNoticeUnReadNum",
		method: "POST",
		data:qs.stringify(data)
	})
}
//消息列表
export  function getIvNoticeList(data) {
	return request({
		url: "/iv-notice/getIvNoticeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//应聘者 - 导出excel
export  function exportIvJobApplicantList(data) {
	return request({
		url: "/iv-job-applicant/exportIvJobApplicantList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑应聘者-隐藏录音和跟进反馈
export  function updateIvJobApplicantHide(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantHide",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑应聘者-权限
export  function updateIvJobApplicantAll(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantAll",
		method: "POST",
		data:qs.stringify(data)
	})
}
//修改密码
export  function updateIvUserPw(data) {
	return request({
		url: "/iv-user/updateIvUserPw",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导出word
export  function exportAjUserWord(data) {
	return request({
		url: "/aj-user/exportAjUserWord",
		method: "POST",
		data:qs.stringify(data)
	})
}
//花名册-详情
export  function getAjUserDetails(data) {
	return request({
		url: "/aj-user/getAjUserDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取花名册-未审核
export  function getAjUserListUnCheck(data) {
	return request({
		url: "/aj-user/getAjUserListUnCheck",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑花名册
export  function updateAjUser(data) {
	return request({
		url: "/aj-user/updateAjUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取民族
export  function getSysNationList(data) {
	return request({
		url: "/sys-nation/getSysNationList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//归属地列表
export  function getAjUserBelongList(data) {
	return request({
		url: "/aj-user/getAjUserBelongList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//中国地区信息 
export  function getSysRegionList(data) {
	return request({
		url: "/sys-region/getSysRegionList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//个人简介
export  function updateIvJobApplicantIntroduction(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantIntroduction",
		method: "POST",
		data:qs.stringify(data)
	})
}
//处理报错接口-查询
export  function getSysMsgErrorGlobalList(data) {
	return request({
		url: "/sys-msg-error-global/getSysMsgErrorGlobalList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//处理报错接口-已处理
export  function updateSysMsgErrorGlobalStatus(data) {
	return request({
		url: "/sys-msg-error-global/updateSysMsgErrorGlobalStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增题目分类
export  function addIvqTopicClass(data) {
	return request({
		url: "/ivq-topic-class/addIvqTopicClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除题目分类
export  function deleteIvqTopicClass(data) {
	return request({
		url: "/ivq-topic-class/deleteIvqTopicClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取题目分类
export  function getIvqTopicClassList(data) {
	return request({
		url: "/ivq-topic-class/getIvqTopicClassList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑题目分类
export  function updateIvqTopicClass(data) {
	return request({
		url: "/ivq-topic-class/updateIvqTopicClass",
		method: "POST",
		data:qs.stringify(data)
	})
}
//题目类型列表
export  function getIvqTopicTypeList(data) {
	return request({
		url: "/ivq-topic-type/getIvqTopicTypeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增试题
export  function addIvqTopic(data) {
	return request({
		url: "/ivq-topic/addIvqTopic",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除试题
export  function deleteIvqTopic(data) {
	return request({
		url: "/ivq-topic/deleteIvqTopic",
		method: "POST",
		data:qs.stringify(data)
	})
}
//试题列表
export  function getIvqTopicList(data) {
	return request({
		url: "/ivq-topic/getIvqTopicList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑试题
export  function updateIvqTopic(data) {
	return request({
		url: "/ivq-topic/updateIvqTopic",
		method: "POST",
		data:qs.stringify(data)
	})
}

//批量上传试题
export  function uploadIvqTopic(data) {
	return request({
		url: "/ivq-topic/uploadIvqTopic",
		method: "POST",
		data
	})
}
//测试详情结果返回
export  function getIvqPaperRecordDetails(data) {
	return request({
		url: "/ivq-paper-record/getIvqPaperRecordDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//测试详情结果列表
export  function getIvqPaperRecordList(data) {
	return request({
		url: "/ivq-paper-record/getIvqPaperRecordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导出花名册头像
export  function getAjUserHeaderFile(data) {
	return request({
		url: "/aj-user-other/getAjUserHeaderFile",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取花名册头像列表
export  function getAjUserListHeader(data) {
	return request({
		url: "/aj-user-other/getAjUserListHeader",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增应聘者权限申请
export  function addIvJobApplicantAuthApply(data) {
	return request({
		url: "/iv-job-applicant-auth-apply/addIvJobApplicantAuthApply",
		method: "POST",
		data:qs.stringify(data)
	})
}
//应聘者权限申请列表
export  function getIvJobApplicantAuthApplyList(data) {
	return request({
		url: "/iv-job-applicant-auth-apply/getIvJobApplicantAuthApplyList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//应聘者权限申请审核
export  function updateIvJobApplicantAuthApplyStatus(data) {
	return request({
		url: "/iv-job-applicant-auth-apply/updateIvJobApplicantAuthApplyStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//取消应聘者申请权限
export  function updateIvJobApplicantAuthApplyStatusCancel(data) {
	return request({
		url: "/iv-job-applicant-auth-apply/updateIvJobApplicantAuthApplyStatusCancel",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取申请个数
export  function getIvJobApplicantAuthApplyNums(data) {
	return request({
		url: "/iv-job-applicant-auth-apply/getIvJobApplicantAuthApplyNums",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增人才库
export  function addIvJobApplicantWare(data) {
	return request({
		url: "/iv-job-applicant-ware/addIvJobApplicantWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除人才库
export  function deleteIvJobApplicantWare(data) {
	return request({
		url: "/iv-job-applicant-ware/deleteIvJobApplicantWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取人才库
export  function getIvJobApplicantWareList(data) {
	return request({
		url: "/iv-job-applicant-ware/getIvJobApplicantWareList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑人才库
export  function updateIvJobApplicantWare(data) {
	return request({
		url: "/iv-job-applicant-ware/updateIvJobApplicantWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑人才库-简历附件
export  function updateIvJobApplicantWareBiographicalNotes(data) {
	return request({
		url: "/iv-job-applicant-ware/updateIvJobApplicantWareBiographicalNotes",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑人才库归属
export  function updateIvJobApplicantWareBelong(data) {
	return request({
		url: "/iv-job-applicant-ware/updateIvJobApplicantWareBelong",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取自己的人才库
export  function getIvJobApplicantWareListMine(data) {
	return request({
		url: "/iv-job-applicant-ware/getIvJobApplicantWareListMine",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增微信工具反馈
export  function addAjWechatFeedback(data) {
	return request({
		url: "/aj-wechat-feedback/addAjWechatFeedback",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除微信工具反馈
export  function deleteAjWechatFeedback(data) {
	return request({
		url: "/aj-wechat-feedback/deleteAjWechatFeedback",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取微信工具反馈
export  function getAjWechatFeedbackList(data) {
	return request({
		url: "/aj-wechat-feedback/getAjWechatFeedbackList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑微信工具反馈
export  function updateAjWechatFeedback(data) {
	return request({
		url: "/aj-wechat-feedback/updateAjWechatFeedback",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑微信工具反馈
export  function updateAjWechatFeedbackReply(data) {
	return request({
		url: "/aj-wechat-feedback/updateAjWechatFeedbackReply",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增微信工具版本记录
export  function addAjWechatVersionRecord(data) {
	return request({
		url: "/aj-wechat-version-record/addAjWechatVersionRecord",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除微信工具版本记录
export  function deleteAjWechatVersionRecord(data) {
	return request({
		url: "/aj-wechat-version-record/deleteAjWechatVersionRecord",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取微信工具版本记录
export  function getAjWechatVersionRecordList(data) {
	return request({
		url: "/aj-wechat-version-record/getAjWechatVersionRecordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑微信工具版本记录
export  function updateAjWechatVersionRecord(data) {
	return request({
		url: "/aj-wechat-version-record/updateAjWechatVersionRecord",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增微信版本内存基址
export  function addAjWechatBase(data) {
	return request({
		url: "/aj-wechat-base/addAjWechatBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除微信版本内存基址
export  function deleteAjWechatBase(data) {
	return request({
		url: "/aj-wechat-base/deleteAjWechatBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取微信版本内存基址
export  function getAjWechatBaseList(data) {
	return request({
		url: "/aj-wechat-base/getAjWechatBaseList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑微信版本内存基址
export  function updateAjWechatBase(data) {
	return request({
		url: "/aj-wechat-base/updateAjWechatBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增错误日志
export  function addAjWechatLogErr(data) {
	return request({
		url: "/aj-wechat-log-err/addAjWechatLogErr",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除错误日志
export  function deleteAjWechatLogErr(data) {
	return request({
		url: "/aj-wechat-log-err/deleteAjWechatLogErr",
		method: "POST",
		data:qs.stringify(data)
	})
}
//处理错误日志
export  function deleteAjWechatLogErrStatus(data) {
	return request({
		url: "/aj-wechat-log-err/deleteAjWechatLogErrStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取错误日志
export  function getAjWechatLogErrList(data) {
	return request({
		url: "/aj-wechat-log-err/getAjWechatLogErrList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取日志
export  function getAjWechatLogList(data) {
	return request({
		url: "/aj-wechat-log/getAjWechatLogList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客Token记录列表
export  function getFxxkTokenList(data) {
	return request({
		url: "/fxxk-token/getFxxkTokenList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客商机记录列表
export  function getFxxkOpportunityList(data) {
	return request({
		url: "/fxxk-opportunity/getFxxkOpportunityList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客商机记录详情
export  function getFxxkOpportunityDetails(data) {
	return request({
		url: "/fxxk-opportunity/getFxxkOpportunityDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客商机 --下载文件到钉盘
export  function updateFxxkOpportunityFilesDesStatus(data) {
	return request({
		url: "/fxxk-opportunity/updateFxxkOpportunityFilesDesStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客行程表记录详情
export  function getFxxkItineraryDetails(data) {
	return request({
		url: "/fxxk-itinerary/getFxxkItineraryDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客行程表记录列表
export  function getFxxkItineraryList(data) {
	return request({
		url: "/fxxk-itinerary/getFxxkItineraryList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客行程表记录-下载到钉盘
export  function updateFxxkItineraryFilesDesStatus(data) {
	return request({
		url: "/fxxk-itinerary/updateFxxkItineraryFilesDesStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客内部支撑记录详情
export  function getFxxkSupportDetails(data) {
	return request({
		url: "/fxxk-support/getFxxkSupportDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客内部支撑记录列表
export  function getFxxkSupportList(data) {
	return request({
		url: "/fxxk-support/getFxxkSupportList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客内部支撑记录-下载到钉盘
export  function updateFxxkSupportFilesDesStatus(data) {
	return request({
		url: "/fxxk-support/updateFxxkSupportFilesDesStatus",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客文件列表
export  function getFxxkFileList(data) {
	return request({
		url: "/fxxk-file/getFxxkFileList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增题目分组
export  function addIvqTopicGroup(data) {
	return request({
		url: "/ivq-topic-group/addIvqTopicGroup",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑题目分组
export  function updateIvqTopicGroup(data) {
	return request({
		url: "/ivq-topic-group/updateIvqTopicGroup",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除题目分组
export  function deleteAjMobileCard(data) {
	return request({
		url: "/ivq-topic-group/deleteAjMobileCard",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取题目分组
export  function getIvqTopicGroupList(data) {
	return request({
		url: "/ivq-topic-group/getIvqTopicGroupList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增面试记录-邀约
export  function addIvJobApplicantRecord(data) {
	return request({
		url: "/iv-job-applicant-record/addIvJobApplicantRecord",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增面试记录-列表
export  function getIvJobApplicantRecordList(data) {
	return request({
		url: "/iv-job-applicant-record/getIvJobApplicantRecordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//修改面试官
export  function updateIvJobApplicantOwner(data) {
	return request({
		url: "/iv-job-applicant/updateIvJobApplicantOwner",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增视频库
export  function addIvOnlineWare(data) {
	return request({
		url: "/iv-online-ware/addIvOnlineWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除视频库
export  function deleteIvOnlineWare(data) {
	return request({
		url: "/iv-online-ware/deleteIvOnlineWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//详情视频库
export  function getIvOnlineWareDetails(data) {
	return request({
		url: "/iv-online-ware/getIvOnlineWareDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取视频库
export  function getIvOnlineWareList(data) {
	return request({
		url: "/iv-online-ware/getIvOnlineWareList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑视频库
export  function updateIvOnlineWare(data) {
	return request({
		url: "/iv-online-ware/updateIvOnlineWare",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增线上简介
export  function addIvOnlineDes(data) {
	return request({
		url: "/iv-online-des/addIvOnlineDes",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除线上简介
export  function deleteIvOnlineDes(data) {
	return request({
		url: "/iv-online-des/deleteIvOnlineDes",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取线上简介
export  function getIvOnlineDesList(data) {
	return request({
		url: "/iv-online-des/getIvOnlineDesList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑线上简介
export  function updateIvOnlineDes(data) {
	return request({
		url: "/iv-online-des/updateIvOnlineDes",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增岗位
export  function addIvOnlinePost(data) {
	return request({
		url: "/iv-online-post/addIvOnlinePost",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除岗位
export  function deleteIvOnlinePost(data) {
	return request({
		url: "/iv-online-post/deleteIvOnlinePost",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑岗位
export  function updateIvOnlinePost(data) {
	return request({
		url: "/iv-online-post/updateIvOnlinePost",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取岗位
export  function getIvOnlinePostList(data) {
	return request({
		url: "/iv-online-post/getIvOnlinePostList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取线上面试记录
export  function getIvOnlineInterviewList(data) {
	return request({
		url: "/iv-online-interview/getIvOnlineInterviewList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取线上面试记录详情
export  function getIvOnlineInterviewDetailsOne(data) {
	return request({
		url: "/iv-online-interview/getIvOnlineInterviewDetailsOne",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客行程表记录-钉钉
export  function getFxxkItineraryDingtalkList(data) {
	return request({
		url: "/fxxk-itinerary-dingtalk/getFxxkItineraryDingtalkList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客行程表记录详情-钉钉
export  function getFxxkItineraryDingtalkDetails(data) {
	return request({
		url: "/fxxk-itinerary-dingtalk/getFxxkItineraryDingtalkDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客行程表记录-每刻
export  function getFxxkItineraryMeikeList(data) {
	return request2({
		url: "/fxxk-itinerary-meike/getFxxkItineraryMeikeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客行程表记录-每刻批量禁用
export  function updateFxxkItineraryMeikeNotSync(data) {
	return request2({
		url: "/fxxk-itinerary-meike/updateFxxkItineraryMeikeNotSync",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客行程表记录-每刻 ---详情
export  function getFxxkItineraryMeikeDetails(data) {
	return request2({
		url: "/fxxk-itinerary-meike/getFxxkItineraryMeikeDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客行程表记录-用户 ---详情
export  function getFxxkItineraryMeikeUserListByUser(data) {
	return request2({
		url: "/fxxk-itinerary-meike/getFxxkItineraryMeikeUserListByUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-钉钉部门
export  function getFxxkDingDepartmentList(data) {
	return request({
		url: "/fxxk-ding-department/getFxxkDingDepartmentList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-钉钉部门编辑
export  function updateFxxkDingDepartment(data) {
	return request({
		url: "/fxxk-ding-department/updateFxxkDingDepartment",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-钉钉部门编辑-全量同步
export  function updateFxxkDingDepartmentSync(data) {
	return request({
		url: "/fxxk-ding-department/updateFxxkDingDepartmentSync",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-钉钉用户
export  function getFxxkDingUserList(data) {
	return request({
		url: "/fxxk-ding-user/getFxxkDingUserList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-钉钉用户-全量同步
export  function updateFxxkDingUserSync(data) {
	return request({
		url: "/fxxk-ding-user/updateFxxkDingUserSync",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-钉钉请假记录
export  function getFxxkDingUserLeaveStatusList(data) {
	return request({
		url: "/fxxk-ding-user-leave-status/getFxxkDingUserLeaveStatusList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除线上面试
export  function deleteIvOnlineInterview(data) {
	return request({
		url: "/iv-online-interview/deleteIvOnlineInterview",
		method: "POST",
		data:qs.stringify(data)
	})
}
//钉钉请假记录详情
export  function getFxxkDingUserLeaveStatusDetails(data) {
	return request({
		url: "/fxxk-ding-user-leave-status/getFxxkDingUserLeaveStatusDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//新增颜色码
export  function addSysExcelColorCode(data) {
	return request({
		url: "/sys-excel-color-code/addSysExcelColorCode",
		method: "POST",
		data:qs.stringify(data)
	})
}
//删除颜色码
export  function deleteSysExcelColorCode(data) {
	return request({
		url: "/sys-excel-color-code/deleteSysExcelColorCode",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取颜色码
export  function getSysExcelColorCodeList(data) {
	return request({
		url: "/sys-excel-color-code/getSysExcelColorCodeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑颜色码
export  function updateSysExcelColorCode(data) {
	return request({
		url: "/sys-excel-color-code/updateSysExcelColorCode",
		method: "POST",
		data:qs.stringify(data)
	})
}
//查询手机型号
export  function getIvOnlineInterviewPhoneModelList(data) {
	return request({
		url: "/iv-online-interview-phone-model/getIvOnlineInterviewPhoneModelList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//试卷列表
export  function getIvqPaperList(data) {
	return request({
		url: "/ivq-paper-base/getIvqPaperList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//背调列表
export  function getIvJobApplicantBackgroundList(data) {
	return request({
		url: "/iv-job-applicant-background/getIvJobApplicantBackgroundList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//背调编辑
export  function updateIvJobApplicantBackground(data) {
	return request({
		url: "/iv-job-applicant-background/updateIvJobApplicantBackground",
		method: "POST",
		data:qs.stringify(data)
	})
}
//背调详情
export  function getIvJobApplicantBackgroundOne(data) {
	return request({
		url: "/iv-job-applicant-background/getIvJobApplicantBackgroundOne",
		method: "POST",
		data:qs.stringify(data)
	})
}
//打分
export  function updateIvqPaperRecordScoreSubject(data) {
	return request({
		url: "/ivq-paper-record/updateIvqPaperRecordScoreSubject",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-部门
export  function getFxxkMeikeDepartmentList(data) {
	return request({
		url: "/fxxk-meike-department/getFxxkMeikeDepartmentList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-部门Tree
export  function getFxxkMeikeDepartmentListTree(data) {
	return request({
		url: "/fxxk-meike-department/getFxxkMeikeDepartmentListTree",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-用户
export  function getFxxkMeikeUserList(data) {
	return request({
		url: "/fxxk-meike-user/getFxxkMeikeUserList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-全量获取用户
export  function updateSyncFxxkMeikeUserAll(data) {
	return request({
		url: "/fxxk-meike-user/updateSyncFxxkMeikeUserAll",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客-全量获取部门
export  function updateSyncFxxkMeikeDepartmentAll(data) {
	return request({
		url: "/fxxk-meike-department/updateSyncFxxkMeikeDepartmentAll",
		method: "POST",
		data:qs.stringify(data)
	})
}
//
//纷享销客讲师
export  function getFxxkMeikeTeacherList(data) {
	return request2({
		url: "/fxxk-meike-teacher/getFxxkMeikeTeacherList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//纷享销客讲师-批量删除
export  function updateFxxkMeikeTeacherNotSync(data) {
	return request2({
		url: "/fxxk-meike-teacher/updateFxxkMeikeTeacherNotSync",
		method: "POST",
		data:qs.stringify(data)
	})
}
//编辑fxxk部门id
export  function updateFxxkMeikeDepartment(data) {
	return request({
		url: "/fxxk-meike-department/updateFxxkMeikeDepartment",
		method: "POST",
		data:qs.stringify(data)
	})
}
//在途推送行程记录详情
export  function getFxxkZaituSyncItineraryDetails(data) {
	return request2({
		url: "/fxxk-zaitu-sync-itinerary/getFxxkZaituSyncItineraryDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
//在途推送行程记录
export  function getFxxkZaituSyncItineraryList(data) {
	return request2({
		url: "/fxxk-zaitu-sync-itinerary/getFxxkZaituSyncItineraryList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//每刻报销单记录
export  function getFxxkMeikeiReimburseList(data) {
	return request2({
		url: "/fxxk-meikei-reimburse/getFxxkMeikeiReimburseList",
		method: "POST",
		data:qs.stringify(data)
	})
}

export  function getFxxkMeikeSupplierList(data) {
	return request2({
		url: "/fxxk-meike-supplier/getFxxkMeikeSupplierList",
		method: "POST",
		data:qs.stringify(data)
	})
}
export  function syncFxxkMeikeSupplierToJindie(data) {
	return request2({
		url: "/fxxk-meike-supplier/syncFxxkMeikeSupplierToJindie",
		method: "POST",
		data:qs.stringify(data)
	})
}

//资产列表
export  function getAjAssetsListNotBelongShenzhen(data) {
	return request3({
		url: "/aj-assets/getAjAssetsListNotBelongShenzhen",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 资产详情
export  function getAjAssetsDetails(data) {
	return request3({
		url: "/aj-assets/getAjAssetsDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 导出-资产-深圳
export  function exportAjAssetsNotBelongShenzhen(data) {
	return request3({
		url: "/aj-assets/exportAjAssetsNotBelongShenzhen",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 批量编辑背调员
export  function updateIvJobApplicantBackgroundBelongUser(data) {
	return request({
		url: "/iv-job-applicant-background/updateIvJobApplicantBackgroundBelongUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-领用记录手册确认归还
export  function updateAjInductionManualBorrowRecordReturn(data) {
	return request3({
		url: "/aj-induction-manual-borrow-record/updateAjInductionManualBorrowRecordReturn",
		method: "POST",
		data:qs.stringify(data)
	})
}
//手册-领用记录手册
export  function getAjInductionManualBorrowRecordList(data) {
	return request3({
		url: "/aj-induction-manual-borrow-record/getAjInductionManualBorrowRecordList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//导出-手册
export  function exportAjInductionManualBase(data) {
	return request3({
		url: "/aj-induction-manual-base/exportAjInductionManualBase",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产管理-资产花名册
export  function getAjUserListAssets(data) {
	return request3({
		url: "/aj-user/getAjUserListAssetsNotBelongShenzhen",
		method: "POST",
		data:qs.stringify(data)
	})
}
//借还记录 
export  function getAjUserBorrowReturnList(data) {
	return request3({
		url: "/aj-user-borrow-return/getAjUserBorrowReturnList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//获取资产登记表详情
export  function getAjUserExpandDetails(data) {
	return request3({
		url: "/aj-user-expand/getAjUserExpandDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 详情花名册
export  function getAjUserDetailsTwo(data) {
	return request3({
		url: "/aj-user/getAjUserDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 花名册 - 换区花名册筛选选项 
export  function getAjUserItem(data) {
	return request3({
		url: "/aj-user/getAjUserItem",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产花名册导出
export  function exportAjUserAssets(data) {
	return request3({
		url: "/aj-user/exportAjUserAssets",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客-报销单类型
export  function getFxxkMeikeiReimburseSubTypeList(data) {
	return request2({
		url: "/fxxk-meikei-reimburse/getFxxkMeikeiReimburseSubTypeList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客-报销导出
export  function exportFxxkMeikeiReimburseList(data) {
	return request2({
		url: "/fxxk-meikei-reimburse/exportFxxkMeikeiReimburseList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//分享销客-发票下载任务
export  function getFxxkMeikeiReimburseDownloadTaskList(data) {
	return request2({
		url: "/fxxk-meikei-reimburse-download-task/getFxxkMeikeiReimburseDownloadTaskList",
		method: "POST",
		data:qs.stringify(data)
	})
}

//花名册-设备借用确认通知
export  function updateAjUserAssetsConfirm(data) {
	return request({
		url: "/aj-user/updateAjUserAssetsConfirm",
		method: "POST",
		data:qs.stringify(data)
	})
}
//资产申请列表
export  function getAjUserBorrowApplyList(data) {
	return request3({
		url: "/aj-user-borrow-apply/getAjUserBorrowApplyList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//面试记录
export  function getIvInterviewApplicantList(data) {
	return request({
		url: "/iv-interview-applicant/getIvInterviewApplicantList",
		method: "POST",
		data:qs.stringify(data)
	})
}
//面试记录-添加关联
export  function updateIvInterviewApplicantSignUser(data) {
	return request({
		url: "/iv-interview-applicant/updateIvInterviewApplicantSignUser",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取菜单权限列表
export  function getAyAuthList(data) {
	return request({
		url: "/ay-auth/getAyAuthList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 新增菜单权限
export  function addAyAuth(data) {
	return request({
		url: "/ay-auth/addAyAuth",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑菜单权限
export  function updateAyAuth(data) {
	return request({
		url: "/ay-auth/updateAyAuth",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除菜单权限
export  function deleteAyAuth(data) {
	return request({
		url: "/ay-auth/deleteAyAuth",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取菜单权限树
export  function getAyAuthTree(data) {
	return request({
		url: "/ay-auth/getAyAuthTree",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取用户权限列表
export  function getAyRoleAuthList(data) {
	return request({
		url: "/ay-role-auth/getAyRoleAuthList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取用户详情
export  function getSysUserDetails(data) {
	return request({
		url: "/iv-user/getSysUserDetails",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 更新用户权限
export  function updateAyRoleAuth(data) {
	return request({
		url: "/ay-role-auth/updateAyRoleAuth",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 获取招聘岗位列表
export  function getIvJobApplicantPostList(data) {
	return request({
		url: "/iv-job-applicant-post/getIvJobApplicantPostList",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 新增招聘岗位
export  function addIvJobApplicantPost(data) {
	return request({
		url: "/iv-job-applicant-post/addIvJobApplicantPost",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 编辑招聘岗位
export  function updateIvJobApplicantPost(data) {
	return request({
		url: "/iv-job-applicant-post/updateIvJobApplicantPost",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 删除招聘岗位
export  function deleteIvJobApplicantPost(data) {
	return request({
		url: "/iv-job-applicant-post/deleteIvJobApplicantPost",
		method: "POST",
		data:qs.stringify(data)
	})
}
	